import styled from 'styled-components';

export const LoaderContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
